module.exports = __webpack_public_path__ + "img/foka80.0d92781a.jpg";